import { useToastContext } from '#pplx/frontend/aether/toasts/context/useToastContext.js';
import { canonicalizeLegacyPermalinkPath } from '#pplx/frontend/apps/ask/permalink-slug/canonicalizeLegacyPermalink.js';
import { useCurrentResultIds } from '#pplx/frontend/apps/ask/providers/ResultsContext.js';
import { useRouter } from '#pplx/frontend/router/provider.js';
import { streamEvents } from '#pplx/frontend/stream/events.js';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';
export const useBackgroundThreadToasts = () => {
    const { openToast } = useToastContext();
    const router = useRouter();
    const { currentStreamId, currentThreadId } = useCurrentResultIds();
    const { $t } = useIntl();
    useEffect(() => {
        const unsubCompleted = streamEvents.on('completed', ({ stream, message }) => {
            if (!document.hasFocus())
                return;
            if (!message)
                return;
            // Reconnectable streams fire a completed event when the initial
            // POST response ends, before the SSE reconnect picks up. Skip
            // these — the real completion will come when the reconnect finishes.
            if (message.reconnectable)
                return;
            // ASI threads receive notification toasts via the SSE metadata channel
            // (useRecentThreadUpdates onNotification callback). Skip here to avoid
            // duplicate toasts.
            if (message.mode === 'ASI')
                return;
            const slug = message.thread_url_slug;
            const title = message.thread_title ?? message.query_str;
            if (!title)
                return;
            if ((currentStreamId && currentStreamId === stream.id.description) ||
                (currentThreadId && currentThreadId === stream.threadId)) {
                return;
            }
            const threadUrl = slug ? canonicalizeLegacyPermalinkPath(`/search/${slug}`) : undefined;
            const toast = {
                message: title,
                description: undefined,
                variant: 'success',
                timeoutSeconds: 8,
                dedupKey: stream.threadId ? `thread-toast:${stream.threadId}` : undefined,
            };
            openToast(threadUrl
                ? { ...toast, ctaText: 'View', ctaOnClick: () => router.push(threadUrl) }
                : { ...toast, ctaText: undefined, ctaOnClick: undefined });
        });
        const unsubError = streamEvents.on('error', ({ stream, message }) => {
            if (!document.hasFocus())
                return;
            // ASI threads receive notification toasts via the SSE metadata channel.
            if (message?.mode === 'ASI')
                return;
            const title = message?.thread_title ?? message?.query_str;
            if (!title)
                return;
            const slug = message?.thread_url_slug;
            if ((currentStreamId && currentStreamId === stream.id.description) ||
                (currentThreadId && currentThreadId === stream.threadId)) {
                return;
            }
            const threadUrl = slug ? canonicalizeLegacyPermalinkPath(`/search/${slug}`) : undefined;
            const toast = {
                message: title,
                variant: 'error',
                timeoutSeconds: 10,
                description: $t({
                    defaultMessage: 'Something went wrong. Please try again.',
                    description: 'Error toast description shown when a background thread stream encounters an error',
                    id: '8e1d8519ff',
                }),
                dedupKey: stream.threadId ? `thread-toast:${stream.threadId}` : undefined,
            };
            openToast(threadUrl
                ? { ...toast, ctaText: 'View', ctaOnClick: () => router.push(threadUrl) }
                : { ...toast, ctaText: undefined, ctaOnClick: undefined });
        });
        return () => {
            unsubCompleted();
            unsubError();
        };
    }, [openToast, router, currentStreamId, currentThreadId, $t]);
};
//# sourceMappingURL=useBackgroundThreadToasts.js.map